import React, { Component } from 'react';
import './index.css';


class TickerPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.handleMouseHover = this.handleMouseHover.bind(this);
  }

  handleMouseHover(e){
    const { ticker } = this.props;
    this.props.onMouseHover(e, ticker)
  }

  render() {
    const { ticker} = this.props;
    const { w,h } = ticker.position;
    let base = Math.min(w, h)
    let baseSize = Math.round(base / 8);
    return (
      <div id='sc-market-map-ticker-price-container' style={{display:baseSize < 8 ? 'none': '', fontSize: baseSize + 'px'}}>
        {ticker.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </div>
    );
  }
}


export default TickerPrice;




